import { setContext } from '@apollo/client/link/context';

import { base64ToString } from '@/utils/stringUtils';
import history from '@/utils/history';

const TIME_TO_LIVE_MS = 1000 * 60 * 60;

const checkForTokenExpiration = () => {
  const tokenCreatedAt: string = localStorage.getItem('tokenCreatedAt') || '';
  if (!tokenCreatedAt) {
    localStorage.clear();
    return;
  }
  const tokenExpiration = new Date(parseInt(base64ToString(tokenCreatedAt), 10) + TIME_TO_LIVE_MS);
  if (tokenExpiration <= new Date()) {
    localStorage.clear();
    history.push('/login');
  }
};

export const withTokenLink = setContext((_, previousContext) => {
  // Skip legacy JWT expiration checks for Supabase-authenticated requests.
  const existingAuth: string = previousContext.headers?.Authorization || previousContext.headers?.authorization || '';
  if (existingAuth.startsWith('Bearer ')) {
    return { headers: { ...(previousContext.headers || {}) } };
  }

  checkForTokenExpiration();

  const token = previousContext.token || localStorage.getItem('token');
  return {
    headers: {
      ...(previousContext.headers || {}),
      authorization: token ? `JWT ${token}` : '',
    },
  };
});
